/**
 * Represents a Role with specific properties and their associated methods.
 */
class Role {

    /**
     * Represents a unique identifier.
     * This variable is typically used to distinguish or refer to a specific item or entity.
     * The value is expressed as a number.
     */
    id: number;

    /**
     * Represents a name.
     * This variable is typically used to distinguish or refer to a specific item or entity.
     * The value is expressed as a string.
     */
    name: string;

    /**
     * Represents a description.
     * This variable is typically used to distinguish or refer to a specific item or entity.
     */
    description: string;

    /**
     * Represents a status.
     * This variable is typically used to distinguish or refer to a specific item or entity.
     */
    active: number;

    /**
     * permission table
     * This variable contain all permissions .
     */
    permissions: Array<any>;

    /**
     * Creates a new instance of the class with the specified properties.
     *
     * @param {number} id - The unique identifier for the instance.
     * @param {string} name - The name of the instance.
     * @param {string} description - A detailed description of the instance.
     * @param {number} active - A flag indicating whether the instance is active (1 for active, 0 for inactive).
     * @param {number} active - A flag indicating whether the instance is active (1 for active, 0 for inactive).
     */
    constructor(
        id: number,
        name: string,
        description: string,
        active: number,
        permissions: Array<any> = []
    ) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.active = active;
        this.permissions = permissions;
    }

    /**
     * Converts a JSON object to a Role instance.
     *
     * @param {any} item - The JSON object to be converted.
     * @return {Role} The Role instance created from the JSON object.
     */
    public static fromJson(item: any): Role {
        return new Role(
            item.id,
            item.name,
            item.description,
            item.active,
            item.permissions
        )
    }

    /**
     * Gets the role's unique identifier
     * @returns The role's ID
     */
    getId(): number {
        return this.id;
    }

    /**
     * Gets the role's name
     * @returns The role's name
     */
    getName(): string {
        return this.name;
    }

    /**
     * Gets the role's description
     * @returns The role's description
     */
    getDescription(): string {
        return this.description;
    }

    /**
     * Determines if the current object is active.
     *
     * @return {boolean} Returns true if the object is active, otherwise false.
     */
    isActive(): boolean {
        return this.active === 1;
    }

    /**
     * Gets the pemission associated with the role. 
     * @returns permissions
     */
    getPermissions(): Array<any> {
        return this.permissions;
    }
}

export default Role;